import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserManagementModel } from '../models/userManagementModel/usermang.model';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    constructor(private location: LocationStrategy) { }

    viewPermissionCheck: any;
    editPermissionCheck: any;
    isAccessDisabled: boolean = false;
    isPageDisabled: boolean = false;
    menusFilter: UserManagementModel[] = [];

    public _normalizeValue(value: string): string {
        if (value)
            return value.toLowerCase().replace(/\s/g, '');
        else
            return '';
    }

    public _permissionCheck(routeName: string): boolean {
       // console.log(routeName);
        this.menusFilter = JSON.parse(localStorage.getItem('menulist'));
       // console.log(this.menusFilter);
        this.menusFilter = this.menusFilter.filter(val => this._normalizeValue(val.nav_page_route).startsWith(this._normalizeValue(routeName)));
       // console.log(this.menusFilter);

        if (this.menusFilter.length > 0) {
            this.editPermissionCheck = this.menusFilter[0].edit_acc;
           // console.log(this.editPermissionCheck);

            if (this.editPermissionCheck === "y") {
                this.isAccessDisabled = false;
            } else {
                this.isAccessDisabled = true;
            }

           // console.log(this.isAccessDisabled);
        }

        return this.isAccessDisabled;
    }

    public _pagePermissionsCheck(routeName: string): boolean {
        console.log(routeName);
        this.menusFilter = JSON.parse(localStorage.getItem('menulist'));
       // console.log(this.menusFilter);
        this.menusFilter = this.menusFilter.filter(val => this._normalizeValue(val.nav_page_route).startsWith(this._normalizeValue(routeName)));
       console.log(this.menusFilter);

        if (this.menusFilter.length > 0) {
            this.viewPermissionCheck = this.menusFilter[0].view_acc;
            console.log(this.viewPermissionCheck);
            this.editPermissionCheck = this.menusFilter[0].edit_acc;
            console.log(this.editPermissionCheck);

           
            if (this.viewPermissionCheck === "y" && this.editPermissionCheck === "y") {
                this.isPageDisabled = false;
            } else {
                this.isPageDisabled = true;
            }

            console.log(this.isPageDisabled);
        }

        return this.isPageDisabled;
    }

    public _disableBackButton() {
        history.pushState(null, null, window.location.href);
        this.location.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
    }
}
